module.exports = __webpack_public_path__ + "static/media/MoleGenVR.67ea0215.png";